// import parseTime, formatTime and set to filter
import moment from 'moment'
export { parseTime, formatTime } from '@/utils'

/**
 * Show plural label if time is plural number
 * @param {number} time
 * @param {string} label
 * @return {string}
 */
function pluralize(time, label) {
  if (time === 1) {
    return time + label
  }
  return time + label + 's'
}

/**
 * @param {number} time
 */
export function timeAgo(time) {
  const between = Date.now() / 1000 - Number(time)
  if (between < 3600) {
    return pluralize(~~(between / 60), ' minute')
  } else if (between < 86400) {
    return pluralize(~~(between / 3600), ' hour')
  } else {
    return pluralize(~~(between / 86400), ' day')
  }
}

/**
 * Number formatting
 * like 10000 => 10k
 * @param {number} num
 * @param {number} digits
 */
export function numberFormatter(num, digits) {
  const si = [
    { value: 1E18, symbol: 'E' },
    { value: 1E15, symbol: 'P' },
    { value: 1E12, symbol: 'T' },
    { value: 1E9, symbol: 'G' },
    { value: 1E6, symbol: 'M' },
    { value: 1E3, symbol: 'k' }
  ]
  for (let i = 0; i < si.length; i++) {
    if (num >= si[i].value) {
      return (num / si[i].value).toFixed(digits).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + si[i].symbol
    }
  }
  return num.toString()
}

/**
 * 10000 => "10,000"
 * @param {number} num
 */
export function toThousandFilter(num) {
  return (+num || 0).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
}

/**
 * Upper case first char
 * @param {String} string
 */
export function uppercaseFirst(string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

// 数字格式化过滤器
export function NumFormat(value) {
  if (!value) return '0'
  var intPart = Number(value).toFixed(0) // 获取整数部分
  var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') // 将整数部分逢三一断
  return intPartFormat
}

export function NumFormatZ(value) {
  if (value == 0) return value
  if (!value) return ''
  var intPart = Number(value).toFixed(0) // 获取整数部分
  var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') // 将整数部分逢三一断
  return intPartFormat
}

// 文件链接过滤器
export function fileLink(value) {
  const link = window.imgUrl + value
  return link
}

// 数字转字符串过滤器
export function numToString(value) {
  const string = value.toString()
  return string
}

// 时间格式化过滤器
export function time(value) {
  moment.locale('ch')
  let day = moment.unix(value)
  let date = moment(day).format('YYYY/MM/DD H:mm')
  return date
}

export function date(value) {
  let day = moment(value)
  let date = moment(day).format('YYYY/MM/DD')
  return date
}

export function week(value) {
  let day = moment(value)
  let date = moment(day).format('ddd')
  return date
}

export function day(value) {
  let day = moment(value)
  let date = moment(day).format('D')
  return date
}

export function month(value) {
  let day = moment(value)
  let date = moment(day).format('M')
  return date
}

export function dataN(value) {
  let day = moment(value)
  let date = moment(day).format('YYYY-MM-DD HH:mm')
  return date
}

export function dateM(value) {
  if (value) {
    let day = moment(value)
    let date = moment(day).format('YYYY-MM-DD HH:mm:ss')
    return date
  } else {
    return ''
  }
}

export function dateYM(value) {
  let day = moment(value)
  let date = moment(day).format('YYYY年MM月DD')
  return date
}

export function dateYMD(value) {
  if (!value) {
    return ''
  }
  let day = moment(value)
  let date = moment(day).format('YYYY-MM-DD')
  return date
}

export function dateMD(value) {
  let day = moment(value)
  let date = moment(day).format('MM-DD')
  return date
}

export function relativeTime(value) {
    // new Date(CST)
    // new Date通过解析currentDateStr返回一个long类型的时间差(UTC时间)来构造日期对象，但这个解析的过程中，如果遇到CST，会被认为是指北美的时区，比格林威治时间(GMT)晚6个小时，按照转换关系，转成UTC需要加6个小时。而在输出receivedCurrentDate的时候会调用toString方法，会根据所在的时区格式化输出日期，也就是将UTC转成China Standard Time，需要加8个小时，所以就出现了相差14个小时
    // var dateStr = value.split(' ')
    // var strGMT = dateStr[0] + ' ' + dateStr[1] + ' ' + dateStr[2] + ' ' + dateStr[5] + ' ' + dateStr[3] + ' GMT+0800'
    // var time = new Date(Date.parse(strGMT))
  let day = moment(value)
    // 判断时间与今天的差值，差几天
  var minutes = day.diff(moment(), 'minutes')

  var tenDayMinutes = 3 * 24 * 60

  if (minutes < -tenDayMinutes) {
    let date = moment(day).format('YYYY-MM-DD')
    return date
  } else if (minutes >= -tenDayMinutes && minutes <= 0) {
    let date = moment(day).format('YYYY-MM-DD HH:mm:ss')
    let relativeTime = moment(date, 'YYYY-MM-DD HH:mm:ss').startOf('minutes').fromNow()
    return relativeTime
  } else if (minutes > 0 && minutes <= tenDayMinutes) {
    let date = moment(day).format('YYYY-MM-DD HH:mm:ss')
    let relativeTime = moment(date, 'YYYY-MM-DD HH:mm:ss').toNow(true) + '之后'
    return relativeTime
  } else if (minutes > tenDayMinutes) {
    let date = moment(day).format('YYYY-MM-DD')
    return date
  }
}



// WEBPACK FOOTER //
// ./src/filters/index.js